<template>
    <div style="padding-right:12px; padding-bottom:12px; padding-left:12px; background: radial-gradient(216.41% 100% at 50% 100%, #FFFFFF 0%, #FFF4EC 38.79%, #FFD5C0 56.72%, #FFE0BA 84.59%, #FFAF79 100%); display: flex; flex-direction: column;">
        <div style="display:flex; flex-direction: column; overflow:auto; flex:1;">
            <div style="position: fixed; left: 0; top: 0; width: 100%; display: flex; justify-content: center; align-items: center; height: 100%; background-color: #00000080; z-index: 200;" v-if="isShowBackground">
                <div style="font-weight: 700; font-size: 20px; color: #fff; height: 25px; overflow: hidden; text-align: center;">
                    <div :style="{ transform: rollingFlag ? 'translateY(0px)' : 'translateY(-25px)' }" style="transition: transform 0.5s;">👏 사커하우에 오신 것을 환영합니다!</div>
                    <div :style="{ transform: rollingFlag ? 'translateY(10px)' : 'translateY(-20px)' }" style="transition: transform 0.5s;">축구의 세계에 빠져들어보세요!</div>
                </div>
            </div>
            <div style="height:16px; flex-shrink: 0; background-color: #f5f5f5; border-radius:12px; width:100%; position:relative; overflow:hidden; margin-top: 19px;">
                <div style="position:absolute; transition: 0.2s all; left:0px;background-color: var(--color-main);height: 100%; border-radius:12px;" :style="{ width: parseInt((progress) / 8 * 100) + '%' }"></div>
            </div>
            <div @click="() => { $GlobalStore.closeLastModal() }" v-if="step !== REGIST_STEP.REGIST_TYPE" style="display: flex; gap: 4px; align-items: center; margin-top: 67px; margin-left: 28px;">
                <div>
                    <img :src="require('@/assets/img/arrow_tick_active.png')" style="rotate: 180deg;" alt="">
                </div>
                <div style="font-weight: 500; font-size: 14px; color: var(--color-main);">뒤로가기</div>
            </div>
            <div v-html="titleText" style="font-size: 32px; font-weight: 700; line-height: 46px; text-align: center; margin-top: 24px; padding-bottom: 12px;"></div>
            <div style="flex: 1; overflow-y: hidden; display: flex; flex-direction: column;"
                :style="{flex : step === REGIST_STEP.REGION ? 'unset' : null, overflowY : step === REGIST_STEP.REGION ? 'unset' : null, display : step === REGIST_STEP.REGION ? 'unset' : null,}"
            >
                <div class="common_wrapper" v-if="step === REGIST_STEP.REGIST_TYPE" style="margin-top: 20px;">
                    <MemberTypeSelectNew :selectRegistType="selectRegistType"></MemberTypeSelectNew>
                </div>
                <div class="common_wrapper" v-if="step === REGIST_STEP.PHONE">
                    <VerificationPhoneNumber :platform="platform" :mode="mode" :registInfo="registInfo" :receivedPhoneNumber="receivedPhoneNumber" :isSendAuthNumber="isSendAuthNumber" :platform_id="registInfo.id"></VerificationPhoneNumber>
                </div>
                <div class="common_wrapper" v-if="step === REGIST_STEP.NAME">
                    <SignupName :setActiveBtn="setActiveBtn" :mode="mode" :registInfo="registInfo" :detectText="detectText"></SignupName>
                </div>
                <div class="common_wrapper" v-if="step === REGIST_STEP.BIRTHDAY">
                    <SignupBirthday :setBirthDate="setBirthDate" :mode="mode" :registInfo="registInfo" :showCalendar="showCalendar" :birth="birth"></SignupBirthday>
                </div>
                <div class="common_wrapper" v-if="step === REGIST_STEP.SEX">
                    <SignupSex :mode="mode" :registInfo="registInfo" :sex="sex" :selectSex="selectSex"></SignupSex>
                </div>
                <div style="" v-if="step === REGIST_STEP.REGION">
                    <SignupRegion :mode="mode" :registInfo="registInfo" :detectSelect="detectSelect"></SignupRegion>
                </div>
                <div class="common_wrapper" v-if="step === REGIST_STEP.RECOMMEND_CODE">
                    <SignupRecommend :mode="mode" :registInfo="registInfo" :detectText="detectText"></SignupRecommend>
                </div>
                <div class="common_wrapper" v-if="step === REGIST_STEP.EXPERT_INFO">
                    <SignupExpertInfo :mode="mode" :registInfo="registInfo" :selectExpertInfo="selectExpertInfo" :expertInfo="expertInfo"></SignupExpertInfo>
                </div>
                <div class="common_wrapper" v-if="step === REGIST_STEP.PURPOSE">
                    <SignupPurpose :mode="mode" :registInfo="registInfo" :purposeList="purposeList" :handlePurposeSelection="handlePurposeSelection" :setSelectPurpose="setSelectPurpose" :selectedPurpose="selectedPurpose"></SignupPurpose>
                </div>
                <div class="common_wrapper" v-if="step === REGIST_STEP.SKILL">
                    <SignupSkill :selectedLengthofPlay="selectedLengthofPlay" :setSelectLengthOfPlay="setSelectLengthOfPlay" :selectedSkill="selectedSkill" :setSelectSkill="setSelectSkill"></SignupSkill>
                </div>
            </div>
        </div>

        <div v-if="isShowNextBtn" style="margin-bottom: 20px;">
            <div @click="nextStep" :style="{ backgroundColor: isActiveBtn ? 'var(--color-main)' : '#ffd2b3' }" style="height: 48px; margin-top: 10px; border-radius: 12px; line-height: 48px; background-color: #ffd2b3; color: #fff; font-weight: 500; font-size: 14px; text-align: center;">다음</div>
        </div>
        <DateSelectorPopupVer2 :is-show-date-selector="isShowDateSelector" :hide="() => { isShowDateSelector = false; }" :complete-action="setBirthDate"></DateSelectorPopupVer2>
        <div style="z-index: 100;">
            <CommonPopupFrame :isOpen="isShowAgreePopup" :closeCompleteAction="closeAgreePopup" :changeHeightUnit="'px'" :changeHeight="405 + $GlobalStore.navigationBarHeight()" :changeBottom="0">
                <div style="padding: 20px 16px">
                    <div style="display: flex; justify-content: space-between; font-weight: 700">
                        <div @click="closeAgreePopup" style="color: #808080; padding-bottom: 12px;">닫기</div>
                        <div @click="submit" style="color: var(--color-main); padding-bottom: 12px;">완료</div>
                    </div>

                    <div style="margin-top: 12px;">
                        <div style="font-size: 14px; font-weight: 500; line-height: 24px; margin-bottom: 4px">서비스 이용 동의</div>
                        <div style="margin-bottom: 12px;" class="common_box">
                            <div style="" class="agree_check_wrap" @click="checkAll">
                                <div class="">
                                    <img style="width: 13px;" v-if="agree[1] && agree[2] && agree[3] && agree[4]" :src="require('@/assets/img/schedule_check_on.png')" />
                                    <img style="width: 13px;" v-else :src="require('@/assets/img/schedule_check_off.png')" />
                                </div>
                                <div class="agree_content">전체동의</div>
                            </div>
                        </div>
                        <div class="common_box">
                            <div style="border-bottom: 1px solid #ebebeb; padding-bottom: 8px;" class="agree_check_wrap" @click="toggleCheck(1)">
                                <div class="">
                                    <img style="width: 13px;" v-if="agree[1]" :src="require('@/assets/img/schedule_check_on.png')" />
                                    <img style="width: 13px;" v-else :src="require('@/assets/img/schedule_check_off.png')" />
                                </div>
                                <div class="agree_content">이용약관, 개인정보 수집 및 이용에 동의합니다.</div>
                            </div>
                            <div style="border-bottom: 1px solid #ebebeb; padding: 8px 0px;" class="agree_check_wrap" @click="toggleCheck(2)">
                                <div class="">
                                    <img style="width: 13px;" v-if="agree[2]" :src="require('@/assets/img/schedule_check_on.png')" />
                                    <img style="width: 13px;" v-else :src="require('@/assets/img/schedule_check_off.png')" />
                                </div>
                                <div class="agree_content">위치기반 서비스 이용약관에 대해 동의합니다.</div>
                            </div>
                            <div style="border-bottom: 1px solid #ebebeb; padding: 8px 0px;" class="agree_check_wrap" @click="toggleCheck(3)">
                                <div class="">
                                    <img style="width: 13px;" v-if="agree[3]" :src="require('@/assets/img/schedule_check_on.png')" />
                                    <img style="width: 13px;" v-else :src="require('@/assets/img/schedule_check_off.png')" />
                                </div>
                                <div class="agree_content">마케팅 메시지 수신을 원합니다.</div>
                            </div>
                            <div v-if="registInfo.register_type == MEMBER_TYPE.COACH" style="padding: 8px 0px;" class="agree_check_wrap" @click="toggleCheck(4)">
                                <div class="">
                                    <img style="width: 13px;" v-if="agree[4]" :src="require('@/assets/img/schedule_check_on.png')" />
                                    <img style="width: 13px;" v-else :src="require('@/assets/img/schedule_check_off.png')" />
                                </div>
                                <div class="agree_content">플랫폼 이용약관에 동의합니다.</div>
                            </div>
                        </div>
                        <div @click="showPrivacyPolicy" style="font-size: 12px; line-height: 20px; color: #808080; margin-top: 30px; text-align: center;">이용약관·개인정보 수집 및 이용</div>
                    </div>
                </div>
            </CommonPopupFrame>
        </div>
        <div>
            <LearnSoccerWriteForm :topic="[]" :isJoin="true" :refresh="refresh" :setSelectPurpose="setSelectPurpose" :isShowWriteForm="isShowWriteForm" :closeWriteForm="closeWriteForm" :formType="formType"></LearnSoccerWriteForm>
        </div>
        <div style="z-index: 110;">
            <PrivacyPolicy v-if="register_type == MEMBER_TYPE.USER" :isShowPrivacyPolicy="isShowPrivacyPolicy" :closePrivacyPolicy="closePrivacyPolicy"></PrivacyPolicy>
        </div>
    </div>
</template>

<script>
const FORM_TYPE = {
    TOPIC: 'TOPIC',
    SKILL: 'SKILL'
}
import CommonPopupFrame from "@/components/modal/my/CommonPopupFrame"
import MemberTypeSelectNew from "@/components/common/MemberTypeSelectNew"
import VerificationPhoneNumber from "@/components/common/VerificationPhoneNumber";
import SignupName from "@/components/common/SignupName";
import SignupRegion from "@/components/common/SignupRegion";
import SignupSex from "@/components/common/SignupSex";
import SignupPurpose from "@/components/common/SignupPurpose";
import SignupBirthday from "@/components/common/SignupBirthday";
import SignupSkill from "@/components/common/SignupSkill";
import SignupExpertInfo from "@/components/common/SignupExpertInfo";
import SignupRecommend from "@/components/common/SignupRecommend";
import DateSelectorPopupVer2 from "@/components/common/DateSelectorPopupVer2";
import PrivacyPolicy from '@/components/modal/PrivacyPolicy'
import { REGIST_STEP, MEMBER_TYPE, GROUP_IDX } from "@/Constants";
import ResponseCode from "@/ResponseCode";
import LearnSoccerWriteForm from '@/components/soccerhowmain/LearnSoccerWriteForm'
import moment from 'moment';

export default {
    name: 'SignupCommonFrame',
    components: { SignupSkill, PrivacyPolicy, LearnSoccerWriteForm, SignupRecommend, SignupExpertInfo, MemberTypeSelectNew, CommonPopupFrame, VerificationPhoneNumber, SignupPurpose, SignupName, SignupBirthday, DateSelectorPopupVer2, SignupSex, SignupRegion },
    props: {
        mode: {
            type: String,
            default: 'insert'
        },
        step: {
            type: String,
            default: REGIST_STEP.REGIST_TYPE
        },
        progress: {
            type: Number,
            default: 1
        },
        isShowNextBtn: {
            type: Boolean,
            default: false
        },
        isSendAuthNumber: {
            type: Boolean,
            default: false
        },
        receivedPhoneNumber: {
            type: String,
            default: ''
        },
        register_type: {
            type: Number,
            default: MEMBER_TYPE.USER
        },
        receivedAuthNumber: {
            type: String,
            default: ''
        },
        receivedRegistInfo: {
            type: Object,
            default: () => { }
        },
        id: {
            type: String,
            default: ''
        },
        password: {
            type: String,
            default: ''
        },
        isFromKaKaoRegist: {
            type: Boolean,
            default: false
        },
        platform: {
            type: Number,
            default: -1
        },
        titleText: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            registType: null,
            REGIST_STEP: REGIST_STEP,
            isActiveBtn: false,
            name: '',
            isShowDateSelector: false,
            birth: '',
            sex: '',
            expertInfo: '',
            selectRegion: null,
            selectedPurpose: null,
            selectedLengthofPlay: null,
            selectedSkill: null,
            isShowAgreePopup: false,
            isShowPrivacyPolicy: false,
            isShowCoachPolicy: false,
            agree: {
                0: false,
                1: false,
                2: false,
                3: false,
                4: false,
            },
            MEMBER_TYPE: MEMBER_TYPE,
            isShowBackground: false,
            rollingFlag: true,
            registInfo: {},
            purposeList: {
                selectedHobby: null,
                selectedLessonType: null,
                selectedEliteCourse: null,
                selectedEtc: null
            },
            GROUP_IDX: GROUP_IDX,
            formType: FORM_TYPE.TOPIC,
            title: '',
            changeHeight: 0,
            temporaryPurpose: '',
            selectedPurposeFlag: false,
            isShowWriteForm: false,
            FORM_TYPE: FORM_TYPE,
            selectedPurposeTitle: '',
            recommend_code: ''
        }
    },
    methods: {
        showPrivacyPolicy() {
            this.isShowPrivacyPolicy = true
        },
        closePrivacyPolicy() {
            this.isShowPrivacyPolicy = false
        },
        refresh() {
            console.log("ㅋ")
        },
        selectExpertInfo(expertInfo) {
            this.expertInfo = expertInfo
            this.isActiveBtn = true
        },
        async registKaKao() {
            // if (this.register_type == MEMBER_TYPE.COACH && !this.agree[4]) {
            //     this.$GlobalStore.showAlert('플랫폼 이용 약관에 동의합니다.');
            //     return;
            // }
            const formData = new FormData()

            formData.append('id', this.registInfo.id);
            formData.append('name', this.registInfo.name);
            formData.append('birthday', this.registInfo.birth.replaceAll('. ', '-'));
            formData.append('sex', this.registInfo.sex === '남성' ? '남' : '여');
            formData.append('authNumber', this.registInfo.authNumber);
            formData.append('phone', this.registInfo.phone);
            formData.append('register_type', this.registInfo.register_type);
            formData.append('visit_reason', this.registInfo.purpose);
            // formData.append('visit_lesson_type', this.registInfo.purpose.selectedLessonType);
            // formData.append('visit_elite_course', this.registInfo.purpose.selectedEliteCourse);
            // formData.append('visit_etc', this.registInfo.purpose.selectedEtc);
            formData.append('level', this.registInfo.skill);
            formData.append('career', this.registInfo.lengthOfPlay);
            formData.append('place_id', this.registInfo.region.id);
            formData.append('place_gps_latitude', this.registInfo.region.gps_latitude);
            formData.append('place_gps_longitude', this.registInfo.region.gps_longitude);
            formData.append('place_name', this.registInfo.region.name);
            formData.append('place_address', this.registInfo.region.address);
            formData.append('mode', this.platform)
            formData.append('recommendee_code', this.registInfo.recommend_code)

            const device = this.$cookies.get("device");
            if (device === "android" || device === "ios") {
                formData.append('pushToken', await window.pushCustomManager.getPushToken())
                formData.append('uuid', await window.pushCustomManager.getUuid())
            }

            formData.append('marketingAgree', this.agree[3] ? "1" : "0")
            formData.append('p_say', null)
            formData.append('l_say', null)
            formData.append('type', null)
            // if (this.registInfo.shortRequest && Object.keys(this.registInfo.shortRequest).length !== 0) {
            //     if (this.registInfo.shortRequest.type === 'p') {
            //         formData.append('p_say', this.registInfo.shortRequest.p_say)
            //     } else if (this.registInfo.shortRequest.type === 'l') {
            //         formData.append('l_say', this.registInfo.shortRequest.l_say)
            //     }
            //     const type = this.registInfo.shortRequest.type === 'l' ? SOCCER_HOW_TYPE.SINGLE_TRAINING : SOCCER_HOW_TYPE.SC_JOIN
            //     formData.append('type', type)
            //     formData.append('isYoutubeExist', this.registInfo.shortRequest.isYoutubeExist)
            //     for (let i = 0; i < this.registInfo.shortRequest.imgSrcArr.length; i++) {
            //         if (this.registInfo.shortRequest.imgSrcArr[i]) {
            //             const curImgSrc = this.registInfo.shortRequest.imgSrcArr[i];
            //             if (curImgSrc.isFileTag) {
            //                 formData.append('file' + i, this.registInfo.shortRequest.imgSrcArr[i].value);
            //             }
            //         }
            //     }
            // }

            try {
                const res = await this.$Axios.post('/regist/kakao', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
                this.isShowBackground = false
                if (res.data.code === 0) {
                    setTimeout(async () => {
                        this.isShowBackground = false
                        localStorage.removeItem('marketing_agree');
                        this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                        this.$GlobalStore.closeModalAll(true)

                        await this.$Util.checkAfterLogin(true);
                        if (this.registInfo.register_type == MEMBER_TYPE.USER) {
                            if (this.registInfo.register_type == MEMBER_TYPE.USER) {
                                const now = moment().format();
                                localStorage.setItem('lastConfirmCloseTime', now);
                                this.$GlobalStore.addModal('SignupFindPosition', { selectedPurpose: this.registInfo.selectedPurposeTitle })
                                // if (this.registInfo.selectedPurposeTitle === GROUP_IDX.COURSE) {
                                //     this.$router.push({ path: '/view/soccer_join?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                                //     this.$GlobalStore.setIsShowRequestPopupForce(true)
                                // } else {
                                //     this.$router.push({ path: '/view/soccer_learn?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                                //     this.$GlobalStore.setIsShowPositionPopup(true)
                                // }
                            }
                        }
                    }, 500);
                } else {
                    alert(res.data.msg);
                }
            } catch (e) {
                alert(JSON.stringify(e));
            }
        },
        async regist() {
            const formData = new FormData();
            formData.append('mode', this.mode)
            formData.append('id', this.registInfo.id);
            formData.append('password1', this.registInfo.password);
            formData.append('name', this.registInfo.name);
            formData.append('birthday', this.registInfo.birth.replaceAll('. ', '-'));
            formData.append('sex', this.registInfo.sex === '남성' ? '남' : '여');
            formData.append('authNumber', this.registInfo.authNumber);
            formData.append('place_id', this.registInfo.region.id);
            formData.append('place_gps_latitude', this.registInfo.region.gps_latitude);
            formData.append('place_gps_longitude', this.registInfo.region.gps_longitude);
            formData.append('place_name', this.registInfo.region.name);
            formData.append('place_address', this.registInfo.region.address);
            formData.append('phone', this.registInfo.phone);
            formData.append('register_type', this.registInfo.register_type);
            formData.append('visit_reason', this.registInfo.purpose);
            formData.append('recommendee_code', this.registInfo.recommend_code)
            // formData.append('visit_lesson_type', this.registInfo.purpose.selectedLessonType);
            // formData.append('visit_elite_course', this.registInfo.purpose.selectedEliteCourse);
            // formData.append('visit_etc', this.registInfo.purpose.selectedEtc);
            formData.append('level', this.registInfo.skill);
            formData.append('career', this.registInfo.lengthOfPlay);

            if (this.registInfo.register_type === MEMBER_TYPE.COACH) {
                formData.append('coach_type', this.registInfo.expertInfo)
            }
            formData.append('p_say', null)
            formData.append('l_say', null)
            formData.append('type', null)

            // if (this.registInfo.shortRequest && Object.keys(this.registInfo.shortRequest).length !== 0) {
            //     if (this.registInfo.shortRequest.type === 'p') {
            //         formData.append('p_say', this.registInfo.shortRequest.p_say)
            //     } else if (this.registInfo.shortRequest.type === 'l') {
            //         formData.append('l_say', this.registInfo.shortRequest.l_say)
            //     }
            //     const type = this.registInfo.shortRequest.type === 'l' ? SOCCER_HOW_TYPE.SINGLE_TRAINING : SOCCER_HOW_TYPE.SC_JOIN
            //     console.log(this.registInfo.shortRequest)
            //     formData.append('type', type)
            //     formData.append('isYoutubeExist', this.registInfo.shortRequest.isYoutubeExist)
            //     for (let i = 0; i < this.registInfo.shortRequest.imgSrcArr.length; i++) {
            //         if (this.registInfo.shortRequest.imgSrcArr[i]) {
            //             const curImgSrc = this.registInfo.shortRequest.imgSrcArr[i];
            //             if (curImgSrc.isFileTag) {
            //                 formData.append('file' + i, this.registInfo.shortRequest.imgSrcArr[i].value);
            //             }
            //         }
            //     }
            // }
            this.$GlobalStore.showProgress()
            const device = this.$cookies.get("device");
            if (device === "android" || device === "ios") {
                formData.append('pushToken', await window.pushCustomManager.getPushToken())
                formData.append('uuid', await window.pushCustomManager.getUuid())
                // parameters.pushToken = await window.pushManager.getPushToken();
                // parameters.uuid = await window.pushManager.getUuid();
            }

            formData.append('marketingAgree', this.agree[3] ? "1" : "0")
            // parameters.marketingAgree = this.agree[3] ? "1" : "0"

            const res = await this.$Axios.post("/api/member/regist", formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            if (res.data.code === 0) {
                this.$GlobalStore.hideProgress()
                this.isShowBackground = true
                if (res.data.is_already_regi_coach) this.$GlobalStore.showAlert("기존에 등록된 코치정보가 있습니다.\n해당 코치정보와 연결합니다.");
                setTimeout(async () => {
                    this.isShowBackground = false
                    // sessionStorage.setItem('IS_LANDING', this.isLanding);
                    this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                    this.$GlobalStore.closeModalAll(true)
                    if (this.register_type == MEMBER_TYPE.COACH) {
                        this.$GlobalStore.addModal('CoachRegisterExplanation', { step: 0, transitionName: 'bottom' })
                    }
                    if (this.registInfo.register_type == MEMBER_TYPE.USER) {
                        const now = moment().format();
                        localStorage.setItem('lastConfirmCloseTime', now);
                        this.$GlobalStore.addModal('SignupFindPosition', { selectedPurpose: this.registInfo.selectedPurposeTitle })
                        // if (this.registInfo.selectedPurposeTitle === GROUP_IDX.COURSE) {
                        //     this.$router.push({ path: '/view/soccer_join?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                        //     this.$GlobalStore.setIsShowRequestPopupForce(true)
                        // } else {
                        //     this.$router.push({ path: '/view/soccer_learn?time=' + new Date().getTime(), props: { data: { mode: 'page' } } });
                        //     this.$GlobalStore.setIsShowPositionPopup(true)
                        // }
                    }
                }, 500);
            } else {
                alert(res.data.msg);
                this.$GlobalStore.hideProgress()
                if (res.data.msg === '이미 회원가입된 전화번호입니다.') {
                    this.isSendAuthNumber = false;
                    this.isAuthNumberChecked = false;
                    this.authNumber = ""
                }
            }
        },
        async saveProfile() {
            const formData = new FormData()
            formData.append('name', this.registInfo.name);
            formData.append('birthday', this.registInfo.birth.replaceAll('. ', '-'));
            formData.append('sex', this.registInfo.sex === '남성' ? '남' : '여');
            formData.append('place_id', this.registInfo.region.id);
            formData.append('place_gps_latitude', this.registInfo.region.gps_latitude);
            formData.append('place_gps_longitude', this.registInfo.region.gps_longitude);
            formData.append('place_name', this.registInfo.region.name);
            formData.append('place_address', this.registInfo.region.address);

            if (this.registInfo.register_type === MEMBER_TYPE.COACH) {
                formData.append('coach_type', this.registInfo.expertInfo)
            } else {
                formData.append('visit_reason', this.registInfo.purpose);
                formData.append('level', this.registInfo.skill);
                formData.append('career', this.registInfo.lengthOfPlay);
                formData.append('p_say', null)
                formData.append('l_say', null)
                formData.append('type', null)
            }


            // if (this.registInfo.shortRequest && Object.keys(this.registInfo.shortRequest).length !== 0) {
            //     if (this.registInfo.shortRequest.type === 'p') {
            //         formData.append('p_say', this.registInfo.shortRequest.p_say)
            //     } else if (this.registInfo.shortRequest.type === 'l') {
            //         formData.append('l_say', this.registInfo.shortRequest.l_say)
            //     }
            //     const type = this.registInfo.shortRequest.type === 'l' ? SOCCER_HOW_TYPE.SINGLE_TRAINING : SOCCER_HOW_TYPE.SC_JOIN
            //     formData.append('type', type)
            //     formData.append('isYoutubeExist', this.registInfo.shortRequest.isYoutubeExist)
            //     for (let i = 0; i < this.registInfo.shortRequest.imgSrcArr.length; i++) {
            //         if (this.registInfo.shortRequest.imgSrcArr[i]) {
            //             const curImgSrc = this.registInfo.shortRequest.imgSrcArr[i];
            //             if (curImgSrc.isFileTag) {
            //                 formData.append('file' + i, this.registInfo.shortRequest.imgSrcArr[i].value);
            //             }
            //         }
            //     }
            // }

            const res = await this.$Axios.post('/api/profile/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.closeModalAll(true)
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                await this.$Util.checkAfterLogin(true);
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
                if (res.data.msg === '이미 회원가입된 전화번호입니다.') {
                    this.isSendAuthNumber = false;
                    this.isAuthNumberChecked = false;
                    this.authNumber = ""
                }
            }
        },
        submit() {
            if (!this.agree[1]) {
                this.$GlobalStore.showAlert('이용약관, 개인정보 수집 및 이용에 동의해주세요.');
                return;
            }

            if (!this.agree[2]) {
                this.$GlobalStore.showAlert('위치기반 서비스 이용약관에 대해 동의해주세요.');
                return;
            }

            if (this.mode === 'update') {
                this.saveProfile()
            } else {
                if (this.registInfo.isFromKaKaoRegist) {
                    this.registKaKao();
                } else {
                    this.regist();
                }
            }
            setTimeout(() => {
                this.rollingFlag = false
            }, 500);
        },
        checkAll() {
            const agreeCnt = Object.keys(this.agree).length;
            let flag = true;
            if (this.agree[0]) flag = false;

            // if (flag) {
            //     if (this.registInfo.register_type == MEMBER_TYPE.USER) {
            //         this.isShowPrivacyPolicy = true
            //     } else if (this.registInfo.register_type == MEMBER_TYPE.COACH) {
            //         this.isShowCoachPolicy = true
            //     }
            // }

            for (let i = 0; i < agreeCnt; i++) {
                this.agree[i] = flag;
            }
        },
        toggleCheck(index) {
            // if (index === 1 && !this.agree[1]) {
            //     if (this.registInfo.register_type == MEMBER_TYPE.USER) {
            //         this.isShowPrivacyPolicy = true
            //     } else if (this.registInfo.register_type == MEMBER_TYPE.COACH) {
            //         this.isShowCoachPolicy = true
            //     }
            // }
            this.agree[index] = !this.agree[index];
        },
        closeAgreePopup() {
            this.isShowAgreePopup = false;
        },
        detectSelect(data) {
            this.selectRegion = data
            if (this.selectRegion.id) {
                this.isActiveBtn = true
            } else {
                this.isActiveBtn = false
            }
        },
        selectRegistType(registType) {

            this.registType = registType
            this.registInfo.register_type = this.registType
            this.$GlobalStore.addModal('SignupCommonFrame', { step: REGIST_STEP.PHONE, progress: 2, receivedRegistInfo: this.registInfo, platform: this.platform })
        },
        setActiveBtn() {
            this.isActiveBtn = true
        },
        detectText(e) {
            if (e.target.value === '' && this.step !== REGIST_STEP.RECOMMEND_CODE) {
                this.isActiveBtn = false
            } else {
                this.isActiveBtn = true
            }

            if (this.step === REGIST_STEP.NAME) {
                this.name = e.target.value
                this.registInfo.name = this.name
            } else if (this.step === REGIST_STEP.RECOMMEND_CODE) {
                this.recommend_code = e.target.value
                this.registInfo.recommend_code = this.recommend_code
            }
        },
        async checkRecommendCode() {
            const parameters = {}
            parameters.recommend_code = this.recommend_code

            const res = await this.$Axios.get('/api/recommend_code/check', {params: parameters})

            if (res.data.code === ResponseCode.SUCCESS) {
                if (this.registInfo.register_type == MEMBER_TYPE.COACH) {
                    this.$GlobalStore.addModal('SignupCommonFrame', { step: REGIST_STEP.EXPERT_INFO, progress: 8, isShowNextBtn: true, receivedRegistInfo: this.registInfo, mode: this.mode, platform: this.platform })
                } else {
                    this.$GlobalStore.addModal('SignupCommonFrame', { step: REGIST_STEP.SKILL, progress: 7, isShowNextBtn: true, receivedRegistInfo: this.registInfo, mode: this.mode, platform: this.platform, titleText: '실력을 알려주세요' })
                }
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        nextStep() {
            if (this.step === REGIST_STEP.NAME) {
                if (this.mode === 'update') {
                    this.name = this.registInfo.name
                }

                if (this.name === '') {
                    alert('이름을 입력해주세요.')
                    return
                }
                if (!this.$Util.checkName(this.name)) {
                    this.$GlobalStore.showAlert('이름은 한글만 가능합니다.');
                    return;
                }
                this.registInfo.name = this.name
                this.$GlobalStore.addModal('SignupCommonFrame', { step: REGIST_STEP.BIRTHDAY, progress: 4, isShowNextBtn: true, receivedRegistInfo: this.registInfo, mode: this.mode, platform: this.platform })
            } else if (this.step === REGIST_STEP.BIRTHDAY) {
                if (this.birth === '') {
                    alert('생년월일을 입력해주세요.')
                    return
                }

                const end_date = moment().format('YYYY-MM-DD');
                const yearsDiff = moment(end_date, "YYYY-MM-DD").diff(moment(this.birth, "YYYY-MM-DD"), 'years');

                if (yearsDiff < 19 && this.registInfo.register_type == MEMBER_TYPE.COACH) {
                    alert("미성년자는 전문가로 가입할 수 없습니다.\n일반 회원으로 변경합니다.");
                    this.registInfo.register_type = MEMBER_TYPE.USER;
                }

                this.registInfo.birth = this.birth
                this.$GlobalStore.addModal('SignupCommonFrame', { step: REGIST_STEP.SEX, progress: 5, isShowNextBtn: true, receivedRegistInfo: this.registInfo, mode: this.mode, platform: this.platform })
            } else if (this.step === REGIST_STEP.SEX) {
                if (this.sex === '') {
                    alert("성별을 선택해주세요.")
                    return
                }
                this.registInfo.sex = this.sex
                this.$GlobalStore.addModal('SignupCommonFrame', { step: REGIST_STEP.REGION, progress: 6, isShowNextBtn: true, receivedRegistInfo: this.registInfo, mode: this.mode, platform: this.platform, titleText: '활동지역을 알려주세요' })
            } else if (this.step === REGIST_STEP.REGION) {
                if (!this.selectRegion || !this.selectRegion.id) {
                    alert("지역을 선택해주세요.")
                    return
                }
                this.registInfo.region = this.selectRegion
                this.$GlobalStore.addModal('SignupCommonFrame', { step: REGIST_STEP.RECOMMEND_CODE, progress: 7, isShowNextBtn: true, receivedRegistInfo: this.registInfo, mode: this.mode, platform: this.platform, titleText: '추천인 코드' })
                // if (this.registInfo.register_type == MEMBER_TYPE.COACH) {
                //     this.$GlobalStore.addModal('SignupCommonFrame', { step: REGIST_STEP.EXPERT_INFO, progress: 8, isShowNextBtn: true, receivedRegistInfo: this.registInfo, mode: this.mode, platform: this.platform })
                // } else {
                //     this.$GlobalStore.addModal('SignupCommonFrame', { step: REGIST_STEP.SKILL, progress: 7, isShowNextBtn: true, receivedRegistInfo: this.registInfo, mode: this.mode, platform: this.platform, titleText: '실력을 알려주세요' })
                // }
            } else if (this.step === REGIST_STEP.RECOMMEND_CODE) {
                this.registInfo.recommend_code = this.recommend_code
                if (this.recommend_code !== '') {
                    this.checkRecommendCode()
                    return
                }
                if (this.registInfo.register_type == MEMBER_TYPE.COACH) {
                    this.$GlobalStore.addModal('SignupCommonFrame', { step: REGIST_STEP.EXPERT_INFO, progress: 8, isShowNextBtn: true, receivedRegistInfo: this.registInfo, mode: this.mode, platform: this.platform })
                } else {
                    this.$GlobalStore.addModal('SignupCommonFrame', { step: REGIST_STEP.SKILL, progress: 7, isShowNextBtn: true, receivedRegistInfo: this.registInfo, mode: this.mode, platform: this.platform, titleText: '실력을 알려주세요' })
                }
            } else if (this.step === REGIST_STEP.SKILL) {
                if (!this.selectedSkill) {
                    alert('실력을 선택해주세요.')
                    return
                }
                if (!this.selectedLengthofPlay) {
                    alert('구력을 선택해주세요.')
                    return
                }
                this.registInfo.skill = this.selectedSkill
                this.registInfo.lengthOfPlay = this.selectedLengthofPlay
                this.$GlobalStore.addModal('SignupCommonFrame', { step: REGIST_STEP.PURPOSE, progress: 8, isShowNextBtn: true, receivedRegistInfo: this.registInfo, mode: this.mode, platform: this.platform, titleText: '사커하우에 오신 이유를<br>알려주세요' })
            } else if (this.step === REGIST_STEP.EXPERT_INFO) {
                if (this.expertInfo === '' || !this.expertInfo) {
                    alert('전문가 정보를 선택해주세요.')
                    return
                }
                this.registInfo.expertInfo = this.expertInfo
                this.isShowAgreePopup = true
            } else if (this.step === REGIST_STEP.PURPOSE) {
                if (!this.selectedPurpose) {
                    alert('사커하우에 오신 이유를 선택해주세요')
                    return
                }
                this.registInfo.purpose = this.selectedPurpose
                this.registInfo.selectedPurposeTitle = this.selectedPurposeTitle
                this.registInfo.shortRequest = this.shortRequest
                this.isShowAgreePopup = true
            }

        },
        checkPurpose() {
            if (!this.purposeList.selectedHobby) {
                alert('취미를 선택해주세요.')
                return false
            } else if (!this.purposeList.selectedLessonType) {
                alert('수업 받기를 선택해주세요.')
                return false
            } else if (!this.purposeList.selectedEliteCourse) {
                alert('엘리트 선수 및 진로를 선택해주세요.')
                return false
            } else if (!this.purposeList.selectedEtc) {
                alert('기타를 선택해주세요.')
                return false
            }
            return true
        },
        showCalendar() {
            this.isShowDateSelector = true;
        },
        setBirthDate(date) {
            this.birth = date.replaceAll('-', '. ');
            this.isActiveBtn = true
        },
        selectSex(sex) {
            this.sex = sex
            this.isActiveBtn = true
        },
        setSelectPurpose(purpose, group_idx, isComplete = false, shortRequest) {
            if (isComplete) {
                this.selectedPurpose = this.temporaryPurpose
                this.isActiveBtn = true
                this.shortRequest = shortRequest
                return
            }
            this.selectedPurpose = purpose
            this.selectedPurposeTitle = group_idx
            this.shortRequest = {}
            this.isActiveBtn = true

            // if (group_idx === GROUP_IDX.COURSE) {
            //     this.temporaryPurpose = purpose
            //     this.formType = FORM_TYPE.TOPIC
            //     this.isShowWriteForm = true
            // } else if (group_idx === GROUP_IDX.LESSON || group_idx === GROUP_IDX.HOBBY) {
            //     this.formType = FORM_TYPE.SKILL
            //     this.temporaryPurpose = purpose
            //     this.isShowWriteForm = true
            // } else {
            //     // this.selectedPurpose = purpose
            //     // this.shortRequest = {}
            //     // this.isActiveBtn = true
            // }
        },
        closeWriteForm() {
            this.isShowWriteForm = false
        },
        checkSkill() {
            if (this.selectedLengthofPlay && this.selectedSkill) {
                this.isActiveBtn = true
            } else {
                this.isActiveBtn = false
            }
        },
        setSelectLengthOfPlay(lengthOfPlay) {
            this.selectedLengthofPlay = lengthOfPlay
            this.checkSkill()
        },
        handlePurposeSelection(type, value) {
            if (type === 'hobby') {
                this.setSelectHobby(value)
            } else if (type === 'lesson') {
                this.setSelectLessonType(value)
            } else if (type === 'elite') {
                this.setSelectEliteCourse(value)
            } else if (type === 'etc') {
                this.setSelectEtc(value)
            }
            const isAllTrue = Object.values(this.purposeList).every(value => value !== null)
            if (isAllTrue) {
                this.isActiveBtn = true
            } else {
                this.isActiveBtn = false
            }
        },
        setSelectHobby(hobby) {
            this.purposeList.selectedHobby = hobby
        },
        setSelectLessonType(lessonType) {
            this.purposeList.selectedLessonType = lessonType
        },
        setSelectEliteCourse(eliteCourse) {
            this.purposeList.selectedEliteCourse = eliteCourse
        },
        setSelectEtc(etc) {
            this.purposeList.selectedEtc = etc
        },
        setSelectSkill(skill) {
            this.selectedSkill = skill
            this.checkSkill()
        }
    },
    created() {
        this.regist = this.$Once(this.regist)
        this.registKaKao = this.$Once(this.registKaKao)
        this.saveProfile = this.$Once(this.saveProfile)
        let phoneNumber;
        let authNumber;
        if (this.step === REGIST_STEP.NAME) {
            this.registInfo.phone = this.receivedPhoneNumber
            this.registInfo.authNumber = this.receivedAuthNumber
            phoneNumber = this.receivedPhoneNumber
            authNumber = this.receivedAuthNumber
        }

        if (this.step === REGIST_STEP.REGIST_TYPE) {
            this.registInfo.id = this.id
            this.registInfo.password = this.password
            this.registInfo.isFromKaKaoRegist = this.isFromKaKaoRegist
        } else {
            this.registInfo = {
                ...this.registInfo,
                ...this.receivedRegistInfo
            }

            if (this.step === REGIST_STEP.NAME && this.mode === 'update') {
                this.registInfo.phone = phoneNumber
                this.registInfo.authNumber = authNumber
            }
        }

        if (this.mode === 'update') {
            this.birth = this.registInfo.birthday
        }

        if (this.step === REGIST_STEP.RECOMMEND_CODE) {
            this.isActiveBtn = true
        }
    }

}
</script>

<style scoped>
.common_wrapper {
    flex: 1; overflow-y: scroll;
}

.common_box {
    padding: 12px;
    background-color: #f5f5f5;
    border-radius: 12px;
}

.agree_check_wrap {
    display: flex;
    align-items: center;
    gap: 20px;
}

.agree_content {
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
}
</style>